import { EuiContextMenu } from '@elastic/eui'
import { ContextMenuProps } from 'props'

const ContextMenu = (props :ContextMenuProps) =>
    <EuiContextMenu {...props}/>

export default ContextMenu